class CifDiffService {
  constructor(httpService) {
    this.http = httpService;
  }
  async execute(clientId) {
    return this.http.get(`/client/diff/${clientId}`)
  }
}

export default CifDiffService